// Unique AI-generated luxury property images
// Italy
import villaPositanoImage from "@/assets/villa-positano-hero.jpg";
import sardiniaCostaSmeraldaImage from "@/assets/sardinia-costa-smeralda.jpg";
import tuscanyWineEstateImage from "@/assets/tuscany-wine-estate.jpg";
import comoLakefrontImage from "@/assets/como-lakefront-villa.jpg";
import sicilyCliffImage from "@/assets/sicily-cliff-villa.jpg";

// Spain
import marbellaZagaletaImage from "@/assets/marbella-zagaleta.jpg";
import ibizaSunsetImage from "@/assets/ibiza-sunset-villa.jpg";
import barcelonaSkylineImage from "@/assets/barcelona-skyline-penthouse.jpg";
import mallorcaCliffImage from "@/assets/mallorca-cliff-estate.jpg";
import marbellaBeachfrontImage from "@/assets/marbella-beachfront.jpg";

// Monaco
import monacoHeightsImage from "@/assets/monaco-heights.jpg";
import monacoPortHerculesImage from "@/assets/monaco-port-hercules.jpg";
import monacoFontveilleImage from "@/assets/monaco-fontvieille.jpg";
import monacoGoldenSquareImage from "@/assets/monaco-golden-square.jpg";
import monacoLarvottoBeachImage from "@/assets/monaco-larvotto-beach.jpg";

// Dubai
import burjKhalifaPenthouseImage from "@/assets/burj-khalifa-penthouse.jpg";
import dubaiMarinaPenthouseImage from "@/assets/dubai-marina-penthouse.jpg";
import palmJumeirahVillaImage from "@/assets/palm-jumeirah-villa.jpg";
import downtownDubaiPenthouseImage from "@/assets/downtown-dubai-penthouse.jpg";
import emiratesHillsMansionImage from "@/assets/emirates-hills-mansion.jpg";
import bluewatersPenthouseImage from "@/assets/bluewaters-penthouse.jpg";

export interface Property {
  id: string;
  title: string;
  location: string;
  price: string;
  image: string;
  beds: number;
  baths: number;
  sqm: string;
  featured: boolean;
  description: string;
  features: string[];
  gallery: string[];
  virtualTourUrl: string;
  floorPlan: {
    levels: { name: string; rooms: string[] }[];
  };
}

export const properties: Property[] = [
  // ITALY - 5 properties
  {
    id: "villa-positano",
    title: "Villa Positano",
    location: "Amalfi Coast, Italy",
    price: "€9,800,000",
    image: villaPositanoImage,
    beds: 6,
    baths: 7,
    sqm: "855",
    featured: true,
    description: "Perched on the dramatic cliffs of the Amalfi Coast, Villa Positano offers an extraordinary blend of historic Italian charm and contemporary luxury. This meticulously restored 18th-century estate features hand-painted majolica tiles, vaulted ceilings, and panoramic terraces cascading down to the azure Mediterranean.",
    features: [
      "Panoramic sea views",
      "Historic architecture",
      "Private lemon grove",
      "Infinity pool overlooking the coast",
      "Wine cellar with tasting room",
      "Helipad access nearby",
      "Private beach access",
      "Outdoor dining terrace"
    ],
    gallery: [villaPositanoImage, villaPositanoImage, villaPositanoImage, villaPositanoImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Main Villa", rooms: ["Grand Salon", "Formal Dining", "Italian Kitchen", "Master Suite", "Library"] },
        { name: "Upper Terrace", rooms: ["3 Guest Suites", "Reading Room", "Panoramic Balcony"] },
        { name: "Garden Level", rooms: ["Pool House", "Summer Kitchen", "Wine Cellar", "Staff Quarters"] }
      ]
    }
  },
  {
    id: "costa-smeralda-estate",
    title: "Costa Smeralda Estate",
    location: "Sardinia, Italy",
    price: "€15,500,000",
    image: sardiniaCostaSmeraldaImage,
    beds: 8,
    baths: 9,
    sqm: "1,300",
    featured: true,
    description: "Set within the exclusive enclave of Porto Cervo, this magnificent estate represents the pinnacle of Mediterranean luxury living. The property spans over two hectares of manicured gardens with direct access to Sardinia's most pristine turquoise waters.",
    features: [
      "Private beach & dock",
      "Infinity pool with sea views",
      "Professional tennis court",
      "Outdoor entertaining pavilion",
      "Guest cottage",
      "Landscaped Mediterranean gardens",
      "Smart home technology",
      "Secure gated entrance"
    ],
    gallery: [sardiniaCostaSmeraldaImage, sardiniaCostaSmeraldaImage, sardiniaCostaSmeraldaImage, sardiniaCostaSmeraldaImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Main Residence", rooms: ["Living Pavilion", "Dining Hall", "Chef's Kitchen", "Media Room", "Office"] },
        { name: "Private Wing", rooms: ["Master Suite", "4 Guest Suites", "Wellness Spa"] },
        { name: "Guest House", rooms: ["3 Bedroom Suite", "Kitchenette", "Private Garden"] },
        { name: "Beach Level", rooms: ["Pool House", "Beach Bar", "Equipment Storage"] }
      ]
    }
  },
  {
    id: "tuscany-estate",
    title: "Tuscan Wine Estate",
    location: "Tuscany, Italy",
    price: "€11,200,000",
    image: tuscanyWineEstateImage,
    beds: 9,
    baths: 10,
    sqm: "1,533",
    featured: false,
    description: "A magnificent Tuscan estate set among rolling hills and vineyards in the heart of Chianti. This historic property combines centuries of Italian heritage with modern luxury, featuring its own producing vineyard, olive groves, and breathtaking views of the Tuscan countryside.",
    features: [
      "Private vineyard & winery",
      "Olive grove production",
      "Heated infinity pool",
      "Historic frescoed ceilings",
      "Professional kitchen",
      "Wine caves",
      "Guest cottages",
      "Helicopter landing"
    ],
    gallery: [tuscanyWineEstateImage, tuscanyWineEstateImage, tuscanyWineEstateImage, tuscanyWineEstateImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Main Villa", rooms: ["Grand Salon", "Formal Dining", "Tuscan Kitchen", "Library", "Office"] },
        { name: "Private Floor", rooms: ["Master Suite", "5 Guest Suites", "Family Room"] },
        { name: "Lower Level", rooms: ["Wine Cellar", "Tasting Room", "Gym", "Cinema"] },
        { name: "Guest Houses", rooms: ["3 Independent Cottages", "Staff Quarters"] }
      ]
    }
  },
  {
    id: "lake-como-villa",
    title: "Villa Bellagio",
    location: "Lake Como, Italy",
    price: "€22,000,000",
    image: comoLakefrontImage,
    beds: 7,
    baths: 8,
    sqm: "1,189",
    featured: true,
    description: "An exceptional lakefront villa on the shores of Lake Como, offering unparalleled views of the Italian Alps. This historic property has been meticulously restored to showcase original frescoes, marble floors, and botanical gardens that descend to a private boat dock.",
    features: [
      "Private boat dock",
      "Historic botanical gardens",
      "Original frescoed ceilings",
      "Heated pool with lake views",
      "Guest house",
      "Direct lake access",
      "Climate-controlled art storage",
      "Caretaker's residence"
    ],
    gallery: [comoLakefrontImage, comoLakefrontImage, comoLakefrontImage, comoLakefrontImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Ground Floor", rooms: ["Grand Entrance", "Formal Reception", "Dining Salon", "Italian Kitchen"] },
        { name: "Piano Nobile", rooms: ["Master Suite", "4 Guest Suites", "Private Study"] },
        { name: "Garden Level", rooms: ["Pool House", "Wine Cellar", "Staff Quarters"] },
        { name: "Lakefront", rooms: ["Boat House", "Guest Cottage", "Entertaining Terrace"] }
      ]
    }
  },
  {
    id: "sicily-coastal-estate",
    title: "Taormina Cliff Estate",
    location: "Sicily, Italy",
    price: "€7,500,000",
    image: sicilyCliffImage,
    beds: 5,
    baths: 6,
    sqm: "725",
    featured: false,
    description: "A stunning cliffside villa in the ancient town of Taormina, offering breathtaking views of Mount Etna and the Ionian Sea. This architectural gem combines traditional Sicilian craftsmanship with contemporary design.",
    features: [
      "Mount Etna & sea views",
      "Infinity pool",
      "Historic architecture",
      "Citrus grove",
      "Outdoor kitchen",
      "Private path to beach",
      "Wine cellar",
      "Staff quarters"
    ],
    gallery: [sicilyCliffImage, sicilyCliffImage, sicilyCliffImage, sicilyCliffImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Main Level", rooms: ["Living Room", "Dining Room", "Kitchen", "Study"] },
        { name: "Upper Level", rooms: ["Master Suite", "3 Guest Bedrooms", "Family Lounge"] },
        { name: "Lower Level", rooms: ["Wine Cellar", "Gym", "Staff Quarters"] }
      ]
    }
  },

  // SPAIN - 5 properties
  {
    id: "villa-serenidad",
    title: "Villa Serenidad",
    location: "Marbella, Spain",
    price: "€8,200,000",
    image: marbellaZagaletaImage,
    beds: 7,
    baths: 8,
    sqm: "1,115",
    featured: true,
    description: "Nestled in the prestigious La Zagaleta estate, Villa Serenidad embodies Mediterranean elegance at its finest. This architectural masterpiece seamlessly blends indoor and outdoor living with expansive terraces, manicured gardens, and breathtaking views of the Mediterranean Sea and Atlas Mountains.",
    features: [
      "Heated infinity pool",
      "Private spa & hammam",
      "Tennis court",
      "Guest house",
      "Mediterranean gardens",
      "State-of-art security",
      "Underground garage",
      "Golf course views"
    ],
    gallery: [marbellaZagaletaImage, marbellaZagaletaImage, marbellaZagaletaImage, marbellaZagaletaImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Ground Floor", rooms: ["Grand Foyer", "Living Salon", "Formal Dining", "Chef's Kitchen", "Library"] },
        { name: "First Floor", rooms: ["Master Suite", "4 Guest Suites", "Family Lounge", "Dressing Rooms"] },
        { name: "Lower Level", rooms: ["Cinema Room", "Gym", "Wine Cellar", "Staff Quarters"] },
        { name: "Guest House", rooms: ["2 Bedroom Suite", "Kitchen", "Private Terrace"] }
      ]
    }
  },
  {
    id: "ibiza-sunset-villa",
    title: "Ibiza Sunset Villa",
    location: "Ibiza, Spain",
    price: "€12,800,000",
    image: ibizaSunsetImage,
    beds: 6,
    baths: 7,
    sqm: "883",
    featured: true,
    description: "An iconic contemporary villa in Ibiza's most exclusive enclave, offering spectacular sunset views over the Mediterranean. This architectural masterpiece features minimalist design with floor-to-ceiling windows, infinity pool, and direct access to a private cove.",
    features: [
      "Legendary sunset views",
      "Infinity edge pool",
      "Private cove access",
      "DJ booth & sound system",
      "Outdoor cinema",
      "Professional kitchen",
      "Guest cottage",
      "Helipad"
    ],
    gallery: [ibizaSunsetImage, ibizaSunsetImage, ibizaSunsetImage, ibizaSunsetImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Main Level", rooms: ["Open Living Space", "Designer Kitchen", "Master Suite", "Entertainment Area"] },
        { name: "Upper Level", rooms: ["3 Guest Suites", "Yoga Studio", "Rooftop Terrace"] },
        { name: "Lower Level", rooms: ["Spa & Wellness", "Gym", "Wine Room"] },
        { name: "Guest House", rooms: ["2 Bedroom Suite", "Kitchen", "Private Pool"] }
      ]
    }
  },
  {
    id: "barcelona-sky-penthouse",
    title: "Barcelona Sky Penthouse",
    location: "Barcelona, Spain",
    price: "€9,500,000",
    image: barcelonaSkylineImage,
    beds: 4,
    baths: 5,
    sqm: "632",
    featured: false,
    description: "An extraordinary duplex penthouse in Barcelona's most prestigious neighborhood, offering panoramic views from the Sagrada Familia to the Mediterranean Sea. This ultra-modern residence features a private rooftop pool, extensive terraces, and world-class finishes.",
    features: [
      "360-degree city views",
      "Private rooftop pool",
      "Smart home system",
      "Wine cellar",
      "Private elevator",
      "Concierge services",
      "Underground parking",
      "Guest suite"
    ],
    gallery: [barcelonaSkylineImage, barcelonaSkylineImage, barcelonaSkylineImage, barcelonaSkylineImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Lower Level", rooms: ["Living Room", "Dining Area", "Gourmet Kitchen", "Guest Suite", "Office"] },
        { name: "Upper Level", rooms: ["Master Suite", "2 Guest Bedrooms", "Family Room"] },
        { name: "Rooftop", rooms: ["Pool Deck", "Outdoor Kitchen", "Lounge Area", "Garden"] }
      ]
    }
  },
  {
    id: "mallorca-cliffside",
    title: "Mallorca Cliffside Estate",
    location: "Mallorca, Spain",
    price: "€14,200,000",
    image: mallorcaCliffImage,
    beds: 8,
    baths: 9,
    sqm: "1,254",
    featured: false,
    description: "A breathtaking cliffside estate on Mallorca's dramatic southwest coast, offering uninterrupted views of the Mediterranean and the island of Cabrera. This exceptional property combines traditional Mallorcan architecture with contemporary luxury.",
    features: [
      "Dramatic cliff location",
      "Infinity pool with sea views",
      "Private beach access",
      "Olive & citrus groves",
      "Tennis court",
      "Wine cellar",
      "Guest house",
      "Boat mooring"
    ],
    gallery: [mallorcaCliffImage, mallorcaCliffImage, mallorcaCliffImage, mallorcaCliffImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Main House", rooms: ["Grand Living Room", "Formal Dining", "Chef's Kitchen", "Library"] },
        { name: "Bedroom Wing", rooms: ["Master Suite", "4 Guest Suites", "Dressing Rooms"] },
        { name: "Lower Level", rooms: ["Spa", "Gym", "Cinema", "Wine Cellar"] },
        { name: "Guest House", rooms: ["3 Bedroom Suite", "Kitchen", "Private Terrace"] }
      ]
    }
  },
  {
    id: "marbella-golden-mile",
    title: "Golden Mile Mansion",
    location: "Marbella, Spain",
    price: "€18,500,000",
    image: marbellaBeachfrontImage,
    beds: 9,
    baths: 10,
    sqm: "1,672",
    featured: false,
    description: "An exceptional beachfront mansion on Marbella's legendary Golden Mile, offering direct Mediterranean beach access and unparalleled luxury. This palatial residence features classical architecture, extensive gardens, and resort-style amenities.",
    features: [
      "Beachfront location",
      "Private beach access",
      "Olympic-size pool",
      "Tennis court",
      "Spa & wellness center",
      "Guest house",
      "Staff quarters",
      "24/7 security"
    ],
    gallery: [marbellaBeachfrontImage, marbellaBeachfrontImage, marbellaBeachfrontImage, marbellaBeachfrontImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Ground Floor", rooms: ["Reception Hall", "Living Salon", "Dining Room", "Kitchen", "Office"] },
        { name: "First Floor", rooms: ["Master Suite", "5 Guest Suites", "Family Room"] },
        { name: "Lower Level", rooms: ["Cinema", "Spa", "Gym", "Wine Cellar", "Game Room"] },
        { name: "Guest House", rooms: ["3 Bedrooms", "Kitchen", "Private Garden"] }
      ]
    }
  },

  // MONACO - 5 properties
  {
    id: "monte-carlo-heights",
    title: "Monte Carlo Heights",
    location: "Monaco",
    price: "€28,000,000",
    image: monacoHeightsImage,
    beds: 4,
    baths: 5,
    sqm: "576",
    featured: true,
    description: "An unparalleled opportunity to own one of Monaco's most coveted addresses. This exceptional apartment offers sweeping views of the legendary Monte Carlo harbor and Mediterranean beyond. Designed by world-renowned architects and finished to the highest specifications.",
    features: [
      "Harbor & sea views",
      "Private terrace",
      "Hermès interior design",
      "Climate-controlled art storage",
      "Professional-grade kitchen",
      "Building concierge",
      "Secure parking spaces",
      "Direct beach access"
    ],
    gallery: [monacoHeightsImage, monacoHeightsImage, monacoHeightsImage, monacoHeightsImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Main Level", rooms: ["Double Reception", "Dining Area", "Bespoke Kitchen", "Master Suite", "Office"] },
        { name: "Upper Level", rooms: ["3 Guest Suites", "Private Lounge", "Terrace Access"] }
      ]
    }
  },
  {
    id: "monaco-harbor-penthouse",
    title: "Port Hercules Penthouse",
    location: "Monaco",
    price: "€45,000,000",
    image: monacoPortHerculesImage,
    beds: 5,
    baths: 6,
    sqm: "790",
    featured: true,
    description: "The ultimate Monaco residence overlooking the legendary Port Hercules and the Grand Prix circuit. This exceptional triplex penthouse offers 360-degree views, a private rooftop pool, and direct access to Monaco's most exclusive amenities.",
    features: [
      "Grand Prix circuit views",
      "Private rooftop pool",
      "Wine cellar",
      "Smart home technology",
      "Private elevator",
      "Yacht club access",
      "24/7 concierge",
      "Secure parking for 4 cars"
    ],
    gallery: [monacoPortHerculesImage, monacoPortHerculesImage, monacoPortHerculesImage, monacoPortHerculesImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Reception Level", rooms: ["Grand Salon", "Formal Dining", "Chef's Kitchen", "Office"] },
        { name: "Private Level", rooms: ["Master Suite", "3 Guest Suites", "Family Room"] },
        { name: "Rooftop", rooms: ["Pool Terrace", "Outdoor Kitchen", "Lounge", "Spa"] }
      ]
    }
  },
  {
    id: "monaco-waterfront-residence",
    title: "Fontvieille Marina Residence",
    location: "Monaco",
    price: "€19,500,000",
    image: monacoFontveilleImage,
    beds: 3,
    baths: 4,
    sqm: "446",
    featured: false,
    description: "An elegant waterfront apartment in Monaco's prestigious Fontvieille district, offering spectacular marina views and yacht-side living. This meticulously designed residence combines classic Mediterranean style with modern luxury.",
    features: [
      "Marina views",
      "Large terrace",
      "High-end finishes",
      "Building pool & gym",
      "Concierge services",
      "Secure parking",
      "Storage unit",
      "Walking distance to amenities"
    ],
    gallery: [monacoFontveilleImage, monacoFontveilleImage, monacoFontveilleImage, monacoFontveilleImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Main Level", rooms: ["Living Room", "Dining Area", "Kitchen", "Master Suite", "2 Guest Bedrooms"] }
      ]
    }
  },
  {
    id: "monaco-carre-dor",
    title: "Carré d'Or Apartment",
    location: "Monaco",
    price: "€32,000,000",
    image: monacoGoldenSquareImage,
    beds: 4,
    baths: 5,
    sqm: "511",
    featured: false,
    description: "A prestigious apartment in Monaco's Golden Square, the principality's most exclusive neighborhood. Steps from the Casino de Monte-Carlo and the Hotel de Paris, this residence offers unmatched luxury and location.",
    features: [
      "Prime Carré d'Or location",
      "Casino & sea views",
      "Bespoke interiors",
      "Smart home system",
      "Wine cellar",
      "24/7 security",
      "Valet parking",
      "Concierge services"
    ],
    gallery: [monacoGoldenSquareImage, monacoGoldenSquareImage, monacoGoldenSquareImage, monacoGoldenSquareImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Main Level", rooms: ["Reception Room", "Dining Room", "Kitchen", "Master Suite"] },
        { name: "Upper Level", rooms: ["3 Guest Suites", "Office", "Terrace"] }
      ]
    }
  },
  {
    id: "monaco-larvotto",
    title: "Larvotto Beach Residence",
    location: "Monaco",
    price: "€24,000,000",
    image: monacoLarvottoBeachImage,
    beds: 4,
    baths: 4,
    sqm: "483",
    featured: false,
    description: "An exceptional beachfront apartment overlooking Monaco's Larvotto Beach. This rare property offers direct beach access, stunning Mediterranean views, and proximity to Monaco's finest restaurants and boutiques.",
    features: [
      "Beachfront location",
      "Mediterranean views",
      "Large terraces",
      "Modern design",
      "Building amenities",
      "Private beach access",
      "Secure parking",
      "Walking distance to shopping"
    ],
    gallery: [monacoLarvottoBeachImage, monacoLarvottoBeachImage, monacoLarvottoBeachImage, monacoLarvottoBeachImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Main Level", rooms: ["Open Living Area", "Kitchen", "Master Suite", "3 Guest Bedrooms", "Terrace"] }
      ]
    }
  },

  // DUBAI - 6 properties
  {
    id: "burj-khalifa-residence",
    title: "Burj Khalifa Residence",
    location: "Dubai, UAE",
    price: "€12,500,000",
    image: burjKhalifaPenthouseImage,
    beds: 5,
    baths: 6,
    sqm: "790",
    featured: true,
    description: "Experience the pinnacle of luxury living in this extraordinary penthouse residence within the iconic Burj Khalifa. Spanning an entire floor with 360-degree panoramic views of the Arabian Gulf, Palm Jumeirah, and the glittering Dubai skyline.",
    features: [
      "Private elevator access",
      "Infinity pool with city views",
      "Smart home automation",
      "Wine cellar & tasting room",
      "Private cinema room",
      "Concierge service 24/7",
      "Secure parking for 4 vehicles",
      "Rooftop terrace"
    ],
    gallery: [burjKhalifaPenthouseImage, burjKhalifaPenthouseImage, burjKhalifaPenthouseImage, burjKhalifaPenthouseImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Main Level", rooms: ["Grand Living Room", "Formal Dining", "Gourmet Kitchen", "Guest Suite", "Office"] },
        { name: "Upper Level", rooms: ["Master Suite", "3 Guest Bedrooms", "Family Room", "Spa & Wellness Center"] },
        { name: "Rooftop", rooms: ["Private Pool", "Entertainment Pavilion", "Outdoor Kitchen", "Garden Terrace"] }
      ]
    }
  },
  {
    id: "dubai-marina-penthouse",
    title: "Marina Skyline Penthouse",
    location: "Dubai Marina, UAE",
    price: "€8,900,000",
    image: dubaiMarinaPenthouseImage,
    beds: 4,
    baths: 5,
    sqm: "669",
    featured: false,
    description: "Rising above the iconic Dubai Marina, this ultra-modern penthouse offers an unrivaled lifestyle in one of the world's most dynamic cities. Floor-to-ceiling windows frame spectacular views of the marina, Palm Jumeirah, and the Arabian Gulf.",
    features: [
      "360-degree panoramic views",
      "Private rooftop terrace",
      "Smart home automation",
      "Chef's kitchen with Gaggenau appliances",
      "Private elevator",
      "Temperature-controlled wine room",
      "Home cinema",
      "3 premium parking spaces"
    ],
    gallery: [dubaiMarinaPenthouseImage, dubaiMarinaPenthouseImage, dubaiMarinaPenthouseImage, dubaiMarinaPenthouseImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Main Level", rooms: ["Open Living Area", "Dining Room", "Gourmet Kitchen", "Guest Suite"] },
        { name: "Upper Level", rooms: ["Master Suite", "2 Guest Bedrooms", "Family Room", "Home Office"] },
        { name: "Rooftop", rooms: ["Sky Lounge", "Outdoor Kitchen", "Jacuzzi", "Entertainment Deck"] }
      ]
    }
  },
  {
    id: "palm-jumeirah-villa",
    title: "Palm Jumeirah Signature Villa",
    location: "Palm Jumeirah, Dubai",
    price: "€18,500,000",
    image: palmJumeirahVillaImage,
    beds: 6,
    baths: 7,
    sqm: "1,068",
    featured: true,
    description: "An exceptional waterfront villa on the prestigious Palm Jumeirah frond, offering private beach access and unobstructed views of the Arabian Gulf. This contemporary masterpiece features soaring double-height ceilings and world-class finishes.",
    features: [
      "Private beach & infinity pool",
      "Direct sea access",
      "Luxury Italian finishes",
      "Smart home integration",
      "Staff quarters",
      "Private dock for yacht",
      "Landscaped tropical gardens",
      "24/7 security & concierge"
    ],
    gallery: [palmJumeirahVillaImage, palmJumeirahVillaImage, palmJumeirahVillaImage, palmJumeirahVillaImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Ground Floor", rooms: ["Grand Reception", "Formal Living", "Dining Room", "Kitchen", "Guest Suite"] },
        { name: "First Floor", rooms: ["Master Suite", "4 Guest Bedrooms", "Family Lounge", "Study"] },
        { name: "Basement", rooms: ["Cinema Room", "Gym", "Spa", "Staff Quarters", "Wine Cellar"] },
        { name: "Exterior", rooms: ["Beach Cabana", "Pool Deck", "Outdoor Kitchen", "Private Dock"] }
      ]
    }
  },
  {
    id: "downtown-dubai-penthouse",
    title: "Downtown Boulevard Penthouse",
    location: "Downtown Dubai, UAE",
    price: "€15,200,000",
    image: downtownDubaiPenthouseImage,
    beds: 5,
    baths: 6,
    sqm: "910",
    featured: false,
    description: "An extraordinary penthouse in the heart of Downtown Dubai, offering front-row views of the Burj Khalifa and Dubai Fountain. This sophisticated residence combines contemporary design with traditional Arabian elements.",
    features: [
      "Burj Khalifa views",
      "Dubai Fountain views",
      "Private terrace",
      "Smart home system",
      "Private elevator",
      "Wine cellar",
      "Cinema room",
      "5 parking spaces"
    ],
    gallery: [downtownDubaiPenthouseImage, downtownDubaiPenthouseImage, downtownDubaiPenthouseImage, downtownDubaiPenthouseImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Main Level", rooms: ["Grand Living Room", "Formal Dining", "Kitchen", "Office", "Guest Suite"] },
        { name: "Upper Level", rooms: ["Master Suite", "3 Guest Bedrooms", "Family Room", "Terrace"] }
      ]
    }
  },
  {
    id: "emirates-hills-mansion",
    title: "Emirates Hills Estate",
    location: "Emirates Hills, Dubai",
    price: "€25,000,000",
    image: emiratesHillsMansionImage,
    beds: 8,
    baths: 10,
    sqm: "2,044",
    featured: true,
    description: "A palatial mansion in Dubai's most prestigious gated community, Emirates Hills. This exceptional property features Mediterranean-inspired architecture, championship golf course views, and the finest luxury amenities available.",
    features: [
      "Golf course views",
      "Olympic pool",
      "Tennis court",
      "Private cinema",
      "Spa & wellness center",
      "Staff quarters",
      "10-car garage",
      "Landscaped gardens"
    ],
    gallery: [emiratesHillsMansionImage, emiratesHillsMansionImage, emiratesHillsMansionImage, emiratesHillsMansionImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Ground Floor", rooms: ["Grand Foyer", "Reception Rooms", "Formal Dining", "Kitchen", "Office"] },
        { name: "First Floor", rooms: ["Master Suite", "5 Guest Suites", "Family Room", "Library"] },
        { name: "Lower Level", rooms: ["Cinema", "Spa", "Gym", "Game Room", "Wine Cellar", "Staff Quarters"] },
        { name: "Exterior", rooms: ["Pool House", "Tennis Court", "Gardens", "Garage"] }
      ]
    }
  },
  {
    id: "bluewaters-island-penthouse",
    title: "Bluewaters Island Penthouse",
    location: "Bluewaters Island, Dubai",
    price: "€11,800,000",
    image: bluewatersPenthouseImage,
    beds: 4,
    baths: 5,
    sqm: "604",
    featured: false,
    description: "A stunning penthouse on Dubai's Bluewaters Island, home to Ain Dubai, the world's largest observation wheel. This contemporary residence offers spectacular views and access to world-class dining and entertainment.",
    features: [
      "Ain Dubai views",
      "Beach access",
      "Rooftop terrace",
      "Smart home system",
      "Private elevator",
      "Building amenities",
      "Secure parking",
      "Concierge services"
    ],
    gallery: [bluewatersPenthouseImage, bluewatersPenthouseImage, bluewatersPenthouseImage, bluewatersPenthouseImage],
    virtualTourUrl: "https://my.matterport.com/show/?m=SxQL3iGyvQk",
    floorPlan: {
      levels: [
        { name: "Main Level", rooms: ["Open Living", "Dining Area", "Kitchen", "Master Suite", "Guest Suite"] },
        { name: "Upper Level", rooms: ["2 Guest Bedrooms", "Family Room", "Rooftop Access"] }
      ]
    }
  }
];

export const getPropertyById = (id: string): Property | undefined => {
  return properties.find(property => property.id === id);
};
